// Separate this into its own file to prevent circular dependencies
import { ImMNElementMap } from '../../../common/elements/elementModelTypes';

export const getElements = (state: any): ImMNElementMap => state.get('elements');
